<template>
  <div>
    <div class="row">
      <div class="col-6">
        <card>
          <h4 class="card-title">
            Beast Configuration
            <button class="btn btn-success pull-right" @click="saveData">
              <font-awesome-icon icon="save"></font-awesome-icon> Save
            </button>
          </h4>
          <fg-input label="Temporary folder location"
                    type="text"
                    v-model="systemConfig.beast.tmpLocation"
                    placeholder="Temporary folder location">
          </fg-input>
          <fg-input label="Packages destination path"
                    type="text"
                    v-model="systemConfig.beast.destinationPath"
                    placeholder="Packages Destination Path">
          </fg-input>
          <fg-input label="Packages destination folder template"
                    type="text"
                    v-model="systemConfig.beast.folderTemplate"
                    placeholder="Packages destination folder template">
          </fg-input>
          <fg-input label="Database export path"
                    type="text"
                    v-model="systemConfig.beast.databaseExportPath"
                    placeholder="Database export path">
          </fg-input>
          <div class="input-group">
            <label class="beast-switch-label">Are the downloads GDPR protected?</label>
            <l-switch v-model="systemConfig.beast.gdprDownloads" class="beast-switch">
              <i class="fa fa-check" slot="on"></i>
              <i class="fa fa-times" slot="off"></i>
            </l-switch>
          </div>
          <div class="input-group">
            <label class="beast-switch-label">Enable user registration?</label>
            <l-switch v-model="systemConfig.beast.userRegistration" class="beast-switch">
              <i class="fa fa-check" slot="on"></i>
              <i class="fa fa-times" slot="off"></i>
            </l-switch>
          </div>
        </card>
      </div>
      <div class="col-6">
        <card>
          <h4 class="card-title">
            Email Configuration
            <button class="btn btn-success pull-right" @click="saveData">
              <font-awesome-icon icon="save"></font-awesome-icon> Save
            </button>
          </h4>
          <fg-input label="Default From Email Address"
                    type="text"
                    v-model="systemConfig.mail.defaults.from"
                    placeholder="From Email">
          </fg-input>
          <fg-input label="Transporter Host"
                    type="text"
                    v-model="systemConfig.mail.transporter.host"
                    placeholder="Email Transporter Host">
          </fg-input>
          <fg-input label="Transporter Port"
                    type="number"
                    step="1"
                    v-model="systemConfig.mail.transporter.port"
                    placeholder="Email Transporter Port">
          </fg-input>
          <div class="input-group">
            <label class="beast-switch-label">Is protocol secure</label>
            <l-switch v-model="systemConfig.mail.transporter.secure" class="beast-switch">
              <i class="fa fa-check" slot="on"></i>
              <i class="fa fa-times" slot="off"></i>
            </l-switch>
          </div>
          <fg-input label="Transporter User"
                    type="text"
                    v-model="systemConfig.mail.transporter.auth.user"
                    placeholder="Email Transporter User">
          </fg-input>
          <fg-input label="Transporter Password"
                    type="password"
                    v-model="systemConfig.mail.transporter.auth.pass"
                    placeholder="Email Transporter Password">
          </fg-input>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Switch as LSwitch, } from "../../components/index";

export default {
  components: {
    LSwitch
  },
  data() {
    return {
      systemConfig: {
        beast: {
          tmpLocation: "",
          destinationPath: "",
          databaseExportPath: "",
          folderTemplate: "",
          gdprDownloads: false,
          userRegistration: true
        },
        mail: {
          transporter: {
            host: "",
            port: 587,
            secure: false,
            auth: {
              user: "",
              pass: ""
            }
          },
          defaults: {
            from: ""
          }
        }
      }
    };
  },
  methods: {
    async refreshData() {
      const response = await this.axios.get("/sysconfig");
      this.systemConfig = response.data;
    },
    async saveData() {
      try {
        await this.axios.post("/sysconfig", this.systemConfig);
      } finally {
        this.refreshData();
      }
    }
  },
  beforeMount() {
    this.refreshData();
  }
};
</script>
<style scoped>
  .beast-switch-label {
    display: inline-block;
    padding-right: 15px;
    line-height: 26px;
  }
</style>
